<img
  [src]="image || '../../../assets/images/avatars/default-user.jpg'"
  alt="Avatar"
  class="custom-avatar"
  [style.width.px]="size"
  [style.height.px]="size"
  onerror="javascript:this.src='assets/images/avatars/default-user.jpg'"
/>
